import { create } from 'zustand';

const useLogsStore = create((set) => ({
  logs: [],
  setLogs: (newLogs) => set({ logs: newLogs }),
}));

export default useLogsStore;

